<template>
    <div class="prosperity-sync">
        <div class="btn btn-sm btn-primary" v-if="canCheckSync && !syncCheckStarted" v-on:click="checkSyncStatus">{{ 'admin.prosperity.checkIfSynced' | lang }}</div>
        <div v-if="syncCheckStarted" class="prosperity-status inProgress">loading</div>
        <div v-if="!canCheckSync" class="prosperity-status"
             v-bind:class="{ synced: synced}">
            <span v-if="synced"> {{ 'admin.prosperity.synced' | lang }}</span>
            <span v-else>{{ 'admin.prosperity.notSynced' | lang }}</span>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: ['userId'],
        data() {
            return {
                synced: undefined,
                syncCheckStarted: false,
            };
        },
        computed: {
            checking() {
                return this.syncCheckStarted;
            },
            canCheckSync() {
                return this.synced === undefined;
            }
        },
        methods: {
            checkSyncStatus() {
                if (this.syncCheckStarted) {
                    return;
                }
                this.syncCheckStarted = true;
                axios.get('/super-admin/check-prosperity-sync/' + this.userId).then(response => {
                    console.log(response);
                    this.synced = response.data.synced;
                    this.syncCheckStarted = false;

                    // Allow checking sync again after 4 seconds.
                    setTimeout(() => {
                      this.synced = undefined;
                    }, 4000)
                }).catch(error => {
                    this.syncCheckStarted = false;
                    console.log(error);
                });
            }
        },
    };
</script>

<style lang="scss">
    .prosperity-status{
        display: inline-flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        padding: 0.125rem 0.5rem;
        border-radius: 4rem;
        color: #fff;
        white-space: nowrap;
        margin: 0;
        background-color: #b93027;
        &.synced{
            background-color: #468145;
        }
        &.inProgress{
            background-color: #767120;
        }
    }
</style>
